module.exports = __webpack_public_path__ + "img/msbank.d5a55d53.png";